/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import ArrangementControls from './panels/ArrangementControls.vue';
import RemoveActiveObject from './panels/RemoveActiveObject.vue';
import PositionControls from './panels/PositionControls.vue';
import DimensionControls from './panels/DimensionControls.vue';
import { BadgeQrCode } from 'shared/libs/providers/badge-editor/qr-code';

/**
 * @emits input the qr code object
 * @emits remove-object void
 * @emits close-panel void
 */
const __vue_script__ = {
    name: 'QrCodePanel',

    components: {
        ArrangementControls,
        RemoveActiveObject,
        PositionControls,
        DimensionControls,
        BaseInput,
    },

    props: {
        value: {
            type: BadgeQrCode,
            required: true,
            default: null,
        },
        pageDimensions: {
            type: Object,
            required: true,
        },
    },

    computed: {
        innerValue: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit('input', value);
            }
        }
    },

    methods: {
        /**
         * @param {object} change
         * @param {'left'|'top'|'width'|'height'} change.property
         * @param {number} change.value
         */
        onChange({ property, value }) {
            this.innerValue[property] = value;

            // qr codes are square, set width and height accordingly
            if (property === 'height') {
                this.innerValue.width = value;
            }
            if (property === 'width') {
                this.innerValue.height = value;
            }
        },

        onRemoveClick() {
            this.$emit('remove-object');
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-panel"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"icon ic-qr-code-element"}),_c('h4',[_vm._v(_vm._s(_vm.$t('badge_editor.qr_code_panel')))])]),_c('div',{staticClass:"controls"},[_c('button',{staticClass:"btn btn-icon single btn-primary-alt close",on:{"click":function($event){return _vm.$emit('close-panel')}}},[_c('i',{staticClass:"icon ic-x"})])])]),_c('div',{staticClass:"section text-input"},[_c('base-input',{attrs:{"type":"text","name":"qrContent","label":_vm.$t('badge_editor.qr_content')},model:{value:(_vm.innerValue.content),callback:function ($$v) {_vm.$set(_vm.innerValue, "content", $$v)},expression:"innerValue.content"}})],1),_c('div',{staticClass:"section parameters"},[_c('dimension-controls',{attrs:{"width":_vm.innerValue.width,"height":_vm.innerValue.height,"page-dimensions":_vm.pageDimensions,"uniform-scaling":true},on:{"change":_vm.onChange}}),_c('position-controls',{attrs:{"top":_vm.innerValue.top,"left":_vm.innerValue.left,"page-dimensions":_vm.pageDimensions},on:{"change":_vm.onChange}}),_c('arrangement-controls',{attrs:{"page-dimensions":_vm.pageDimensions},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1),_c('div',{staticClass:"section actions"},[_c('remove-active-object',{on:{"click":_vm.onRemoveClick}})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QrCodePanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__